import React from 'react';
import { withAuth } from "../../app/util/HOC";
import StudentInsights from './StudentInsights';
import ProfessorInsights from './ProfessorInsights';
export function CommonInsights() {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    return (
        <div>
            {userVO.userRoleId !== undefined && userVO.userRoleId === "10" ? <ProfessorInsights /> : <StudentInsights />}
        </div>
    );
}
export default withAuth(CommonInsights);